export default __webpack_public_path__ + "static/media/logo2.cc9d95a8.png";